// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2aF-v","head":"ProcedureTableInfo_head__1H-8N"};